

import { Container } from 'inversify';
import { computed, defineComponent, onBeforeUpdate, onMounted, ref, watch } from 'vue';
import { FilterMatchMode, FilterOperator } from 'primevue/api';
//import TableExport from '../../tabla/TableExport.vue';
import NewRegister from './NewRegister.vue'
import MasiveUpdate from './MasiveUpdate.vue';
import { useI18n } from 'vue-i18n';
//import Mic from '../   ../../mic/Mic.vue'
import Mic from '../../../../../common/infrastructure/componentes/base/common/mic/Mic.vue';
import TableExport from '../../../../../common/infrastructure/componentes/base/common/tabla/TableExport.vue';
import { messages } from './localization/MessagesBusqueda';
import { IapCatalog } from '../../../catalog/domain/iapCatalog';

import { menuPrime } from '../../../../../common/domain/modelos/menu/CustomMenuPrime';
import DataSourceComp from '../functions/dataSourceComp';
import { dataUpdate } from '../../../dataupdate/domain/dataUpdate';
import { IServiceDataUpdate } from '../../../dataupdate/application/IServiceDataUpdate';
import { TYPES } from '../../../../../common/domain/types';
import HelperLoading from '../../../../../common/infrastructure/funciones/HelperLoading';
import OperationDataTypeConst from '../../../../../common/domain/constantes/OperationDataTypeConst';
import { clave } from '../../../dataupdate/domain/clave';
import TableConst from '../../../../../common/domain/constantes/TableIcons';
import ActionTypeConst from '../../../../../common/domain/constantes/ActionTypeConst';
import SqlTypesConst from '../../../../../common/domain/constantes/SqlTypesConst';

import ImportDataThrowDataSource from '../../../datasource/infrastructure/Component/ImportDataThrowDataSource.vue';
import { IapComponentDataSource } from '../../../component/domain/iapComponentDataSource';
import { MessageService } from '../../../../../common/infrastructure/servicios';
import { MessageType } from '../../../../../common/infrastructure/servicios/MessageService';
import DataSourceConst from '../functions/dataSourceConst';
import { MenuItem } from 'primevue/menuitem';
import CatalogDataTypeConst from '../../../catalog/domain/const/CatalogDataTypeConst';
import { useStore } from 'vuex';
import { IapComponent } from '../../../component/domain/iapComponent';
import HelperUtils from '../../../../../common/infrastructure/funciones/HelperUtils';
import LookUpEditor from './LookUpEditor.vue';
import HelperCommon from '../../../../../common/infrastructure/funciones/HelperCommon';
import LookUpSearchTable from './LookUpSearchTable.vue';
import Column from 'primevue/column';
import { DataTableCellEditInitEvent } from 'primevue/datatable';
import dataSourceFieldConst from '../../../datasource/domain/const/dataSourceFieldConst';


export default defineComponent({
    name: 'search_detail',
    emits: ['update:modelValue', 'update:catalogosData', 'click:action','click:SelectRow','click:viewDetail', 'click:refreshData', 'click:addCustom'],
    props: {
        container: {
            type: Object as () => Container
        },
        rootParentId:
        {
            type: Number,
            default: (-1)
        },

        Component: {
            type: Object as () => IapComponent,
            default: () => ({})
        },
        modelValue: {
            type: Object as () => [],
            default: () => ([])
        },
        filterTablas: {
            type: Object as () => string[],
            default: () => ([])
        },

        compDataSource: {
            type: Object as () => IapComponentDataSource,
            default: () => ({})
        },
        catalogosData: {
            type: Object as () => IapCatalog[],
            default: () => ([])
        },
        filasPorPagina: {
            type: Object as () => number[],
            default: () => ([5, 10, 25, 50, 100])
        },
        editAllExceptKeys: {
            type: Boolean,
            default: false
        },
        canAddNewItem: {
            type: Boolean,
            default: true
        },
        canImport: {
            type: Boolean,
            default: true
        },
        canEdit: {
            type: Boolean,
            default: false
        },
        canDeleteItem: {
            type: Boolean,
            default: false
        },

        showActionMenu: {
            type: Boolean,
            default: false
        },
        showActionDetail: {
            type: Boolean,
            default: false
        },
        showPaginator: {
            type: Boolean,
            default: true
        },
        canUpdateMassive: {
            type: Boolean,
            default: true
        },
        menuActionItems: {
            type: Object as () => MenuItem[],
            default: []
        },
        showSearch: {
            type: Boolean,
            default: true
        },
        showHeaderDetail: {
            type: Boolean,
            default: true
        },
        customAddNew: {
            type: Boolean,
            default: false
        },

    },
    components: {
        TableExport,
        NewRegister,
        Mic,
        MasiveUpdate,
        ImportDataThrowDataSource,
        LookUpEditor,
        LookUpSearchTable
    },
    setup(props, { emit }) {
        const store = useStore();
        const { t, locale } = useI18n(messages)
        const { isType, isCatalogTypeByFieldId, isCatalogType, getCatalogData, getCatalogTypeByFieldId, isColumnIdtipoCampoType, isColumnType, formatData, mustFormatData
            , tablas, tablasData, dataBaseId, hasLookUpByFieldId, getLookUpByFieldId, hasLookUpByFieldType,getDefaultvalue } = DataSourceComp(props.container as any, props, emit, t, props.compDataSource, props.catalogosData,store)
        const dt = ref();
        const op = ref(false);
        const dialogVisible = ref(false);
        const opMassiveUpdate = ref(false);
        const menus = ref<menuPrime[]>([]);
        const selectedColumns = ref();// ref(columns.value.slice(0, 3));
        let withHeaders = ref(false);
        const selectedItems = ref([]);
        const showHeader = ref(true);
        const lookUpData = ref();
        const dataSourceLookUpId = ref()
        


        const itemsMenuRadial = ref([
    {
        label: 'Añadir',
        icon: 'pi pi-pencil',
        command: (evt:any) => {
            toggleNew(evt);
        },
        visible:props.canAddNewItem
    },
    {
        label: 'Importar',
        icon: 'pi pi-file-import',
        command: (evt:any) => {
            toggleNew(evt);
        },
        visible:props.canImport
    },

    {
        label: 'Importar Masivo',
        icon: 'pi pi-save',
        command: (evt:any) => {
            toggleNew(evt);
        },
        visible:props.canUpdateMassive && selectedItems.value.length > 0
    },

    
    {
        label: 'Ver',
        icon: 'pi pi-refresh',
        command: () => {
            showHeader.value = !showHeader.value
        },
        visible:props.showHeaderDetail
    },
    
])
        const filters = ref({
            'global': { value: '', matchMode: FilterMatchMode.CONTAINS },
            'date': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
        });

        const data = computed({
            get: () => props.modelValue,
            set: (val) => emit('update:modelValue', val),
        });



        const catalogos = computed({
            get: () => props.catalogosData,
            set: (val) => emit('update:catalogosData', val),
        });

        const getIconHeader = computed(() => {
            return !showHeader.value ? 'pi pi-plus-circle' : 'pi pi-minus-circle'
        })

        const columnsFiltered = computed(() => {
            let _cols = [] as any;
            props.filterTablas.forEach(tablaName => {
                const fields = tablasData.value.filter(x => x.dataSourceTableAliasId !== null && x.tableName == tablaName && props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == x.id)?.filterSearch && props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == x.id)?.list)
                    .sort((a, b) => { return (props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == a.id)?.filterSearchOrder ?? 0) - (props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == b.id)?.filterSearchOrder ?? 0); })
                    .map(x => dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field)
                _cols = _cols.concat(fields)
            })

            const customFields = tablasData.value.filter(x => x.dataSourceTableAliasId == null && props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == x.id)?.filterSearch && props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == x.id)?.list)
                .sort((a, b) => { return (props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == a.id)?.filterSearchOrder ?? 0) - (props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == b.id)?.filterSearchOrder ?? 0); })
                .map(x => dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.fieldAlias)

            if (customFields.length > 0) {
                _cols = _cols.concat(customFields)
            }



            return _cols;
        })

        const columnsFilteredList = computed(() => {
            let _cols = [] as any;
            if ((selectedColumns.value?.length ?? 0) == 0) {
                selectedColumns.value = columnsFiltered.value
            }
            props.filterTablas.forEach(tablaName => {
                const fields = tablasData.value.filter(x => x.dataSourceTableAliasId != null && x.tableName == tablaName && props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == x.id)?.list && selectedColumns.value.includes((dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) as any))
                    .sort((a, b) => { return (props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == a.id)?.filterResultOrder ?? 0) - (props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == b.id)?.filterResultOrder ?? 0); })
                    .map(x => ({ header: x.shortDescription ?? x.field, field: dataBaseId.value + DataSourceConst.DELIMITERFIELDS +  (!HelperCommon.isNullOrWhitespace(x.tableNameAlias ?? '')?  x.tableNameAlias:  x.tableName) + DataSourceConst.DELIMITERFIELDS + x.field }))

                _cols = _cols.concat(fields)
            })

            const customFields = tablasData.value.filter(x => x.dataSourceTableAliasId == null && props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == x.id)?.list && selectedColumns.value.includes((dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.fieldAlias) as any))
                .sort((a, b) => { return (props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == a.id)?.filterResultOrder ?? 0) - (props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == b.id)?.filterResultOrder ?? 0); })
                .map(x => ({ header: x.shortDescription ?? x.fieldAlias, field: dataBaseId.value + DataSourceConst.DELIMITERFIELDS + DataSourceConst.AGGREGATE_TABLE + DataSourceConst.DELIMITERFIELDS + x.fieldAlias }))

            if (customFields.length > 0) {
                _cols = _cols.concat(customFields)
            }

            return _cols;

        })



        const onToggle = (val: any) => {
            selectedColumns.value = val as any;// columns.value.filter((col: any) => val.includes(col));   //val as any;         
        };


        const saveData = (originalData: any, campo: any, valor: any, data: dataUpdate, transactionOperation: boolean = false) => {
            if (props.container) {
                const _srv = props.container.get<IServiceDataUpdate>(TYPES.DATAUPDATE_REPOSITORY)
                HelperLoading.showSaving()
                const requestData = JSON.parse(JSON.stringify(data))
                _srv.update(props.Component.applicationId, props.Component.applicationVersion, props.Component.id, props.compDataSource.id, [requestData], transactionOperation).then(response => {
                    if (response) {

                        if (response.length > 0) {

                            // se va a actualizar el lookupdescription
                            if (lookUpData.value) {
                                const dsLk = tablasData.value.find(x => campo == (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field))

                                // se actualiza la descripción
                                const _source = campo + DataSourceConst.DELIMITERFIELDLOOKUPDESCRIPTION;
                                const _dest = DataSourceConst.LOOKUPDESC;
                                originalData[_source] = lookUpData.value[_dest]


                                // se actualizan el resto de campos
                                Object.keys(lookUpData.value).filter(x => x != DataSourceConst.LOOKUPID
                                    && x != DataSourceConst.LOOKUPDESC
                                ).forEach(_field => {
                                    const newValue = lookUpData.value[_field]
                                    const dslnkFields = dsLk?.dataSourceLookUp?.dataSource.iapDataSourceFields.map(x => ({ id: x.id, field: (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) }));
                                    const dataSourceFieldIdSource = dslnkFields?.find((x: any) => x.field == _field)?.id;
                                    const dataSourceFieldIdTarget = dsLk?.dataSourceLookUp?.iapDataSourceLookUpFieldMaps.find(x => x.dataSourceFieldIdSource == dataSourceFieldIdSource)?.dataSourceFieldIdTarget;

                                    const _fieldToUpdate = tablasData.value.find(x => x.id == dataSourceFieldIdTarget)

                                    const _fieldNew = (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + _fieldToUpdate?.tableName + DataSourceConst.DELIMITERFIELDS + _fieldToUpdate?.field)


                                    originalData[_fieldNew] = newValue
                                    originalData[_fieldNew + DataSourceConst.DELIMITERFIELDFORMAT] = formatData(originalData, _fieldNew)
                                })

                                lookUpData.value = null;

                            }

                            data.valores.forEach( item=> {
                                const newKey = (item.field !== campo ? item.field : campo);
                                const newValue = (item.field !== campo ? item.value : valor);

                                originalData[newKey] = newValue;
                                originalData[newKey + DataSourceConst.DELIMITERFIELDFORMAT] = formatData(originalData, newKey)

                            })

                        }
                        else {
                            const errors = response.filter(x => x.result == false && !HelperCommon.isNullOrWhitespace((x?.error ?? ''))).map(x => x.error);
                            if (errors.length > 0) {
                                MessageService.showMessage(MessageType.Error, "Error actualizando datos", errors.join('<br>'));

                            }
                        }
                    }
                })
                    .finally(() => {
                        HelperLoading.hideSaving()
                    })
            }
        }


        const deleteData = (data: dataUpdate) => {
            if (props.container) {
                const _srv = props.container.get<IServiceDataUpdate>(TYPES.DATAUPDATE_REPOSITORY)
                HelperLoading.showSaving()
                const requestData = JSON.parse(JSON.stringify(data))
                _srv.update(props.Component.applicationId, props.Component.applicationVersion, props.Component.id, props.compDataSource.id, [requestData], false).then(response => {
                    if (response) {
                        MessageService.showToast(MessageType.Correcto, "", 'Registro eliminado correctamente.');
                        emit('click:refreshData');
                    }

                })
                    .finally(() => {
                        HelperLoading.hideSaving()
                    })
            }
        }






        const getData = computed(() => {

            var data = [] as any;



            if (props.filterTablas.length > 0) {
                tablas.value.forEach(x => {
                    let itemsFields = tablasData.value.filter(t => t.dataSourceTableAliasId != null && t.tableName == x.tableName && props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == t.id)?.list).sort((a, b) => { return (props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == a.id)?.filterResultOrder ?? 0) - (props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == b.id)?.filterResultOrder ?? 0); }).map(t => ({ label: t.shortDescription ?? t.field, tabla: t.tableName, value: dataBaseId.value + DataSourceConst.DELIMITERFIELDS + t.tableName + DataSourceConst.DELIMITERFIELDS + t.field, disabled: false }));
                    const itemsCustomFields = tablasData.value.filter(t => t.dataSourceTableAliasId == null && props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == t.id)?.list).sort((a, b) => { return (props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == a.id)?.filterResultOrder ?? 0) - (props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == b.id)?.filterResultOrder ?? 0); }).map(t => ({ label: t.shortDescription ?? t.fieldAlias, tabla: t.tableName, value: dataBaseId.value + DataSourceConst.DELIMITERFIELDS + t.tableName + DataSourceConst.DELIMITERFIELDS + t.fieldAlias, disabled: false }));

                    itemsFields = itemsFields.concat(itemsCustomFields as any)
                    const aux = {
                        header: x,
                        label: x.shortDescription,
                        icon: x.idIcon ?? 'pi pi-list',//x.icon,
                        code: x, //x.key,
                        items: itemsFields
                    }

                    data.push(aux);
                })
            }




            selectedColumns.value = columnsFiltered.value;//data.filter(x=> x. )// columnsFiltered.value.map( (z: { value: any; }) => z.value)
            return data;
        })


        const isEdit = (columna: string) => {
            const item = tablasData.value.find(x => (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) == columna)
            if (props.editAllExceptKeys) {
                return !(item?.primaryKey ?? true)
            }
            else {
                return (props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == item?.id)?.edit ?? false) && ((item?.primaryKey ?? true) == false)
            }
        }


        const toggleNew = (event: any) => {

            if (!props.customAddNew) {
                op.value = true;
            }
            else {
                // se la creación externa
                emit('click:addCustom');
            }

        }

        const toggleImport = (event: any) => {
            dialogVisible.value = true;
        }

        const toggleUpdateMassive = (event: any) => {
            opMassiveUpdate.value = true;
        }

        const onCellEditInit = (event:  DataTableCellEditInitEvent) => {      
            selectRow(event.data);
        }


        const onCellEditCancel = (event: any) => {
            emit('click:SelectRow', null)
        }





        const  onCellEditComplete = (event: any) => {

            let { data, newData, field } = event;
            const _field = field.replace(DataSourceConst.DELIMITERFIELDFORMAT, '')
            let tableName ='';
            const newValue = newData[_field]
            if (data[_field] !== newValue) {
                tableName = tablasData.value.find(x => _field == (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field))?.tableName ?? ''
                //data[field] = newValue
                const mustSerialize = isColumnType(_field, SqlTypesConst.BIT)
                const dataUpdate: dataUpdate = {
                    valores: [{
                        dataBase: dataBaseId.value ?? '',
                        table: tableName ?? '',
                        field: _field,
                        value: mustSerialize ? JSON.stringify(newValue) as any : newValue as any,//JSON.stringify(newValue) as any
                    }],
                    claves: getPrimaryKeys(data, _field),
                    tipoOperacion: OperationDataTypeConst.UPDATE,
                    id: HelperUtils.newGuid()
                };

                // si tenemos esto es un lookup
                if (lookUpData.value) {
                    const dsLk = tablasData.value.find(x => _field == (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field))

                    Object.keys(lookUpData.value).filter(x => x != DataSourceConst.LOOKUPID
                        && x != DataSourceConst.LOOKUPDESC
                    ).forEach(_field => {
                        const dslnkFields = dsLk?.dataSourceLookUp?.dataSource.iapDataSourceFields.map(x => ({ id: x.id, field: (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) }));
                        const dataSourceFieldIdSource = dslnkFields?.find((x: any) => x.field == _field)?.id;
                        const dataSourceFieldIdTarget = dsLk?.dataSourceLookUp?.iapDataSourceLookUpFieldMaps.find(x => x.dataSourceFieldIdSource == dataSourceFieldIdSource)?.dataSourceFieldIdTarget;

                        const _fieldToUpdate = tablasData.value.find(x => x.id == dataSourceFieldIdTarget)

                        const _fieldNew = (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + _fieldToUpdate?.tableName + DataSourceConst.DELIMITERFIELDS + _fieldToUpdate?.field)
                        const mustSerialize = isColumnType(_field, SqlTypesConst.BIT)
                        const newValue = lookUpData.value[_field]
                        if (
                            (_fieldToUpdate?.nullable == true) // columnas que admiten nulos
                            || (_fieldToUpdate?.nullable == false && !(newValue == null || newValue == undefined))) // columnas no nulas que llegan valores nulos
                        {


                            dataUpdate.valores.push
                                (
                                    {
                                        dataBase: dataBaseId.value ?? '',
                                        table: tableName ?? '',
                                        field: _fieldNew,
                                        value: mustSerialize ? JSON.stringify(newValue) as any : newValue as any,//JSON.stringify(newValue) as any
                                    })
                        }
                    })
                    //dataUpdate.u
                }

                // se añaden los autoupdate de la configuración del componentdatasource
                props.compDataSource.iapComponentDataSourceFieldConfigurations.filter(x => x.autoUpdate)
                    .forEach(cfg => {
                        const _fieldToUpdate = tablasData.value.find(x => x.id == cfg.dataSourceFieldId && x.tableName == tableName);
                        if (_fieldToUpdate) {

                            const newField = (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + _fieldToUpdate.tableName + DataSourceConst.DELIMITERFIELDS + _fieldToUpdate.field);
                            const newTableName = _fieldToUpdate?.tableName;
                            const newFieldValue = getDefaultvalue(_fieldToUpdate,cfg.defaultValue)
                            //data[field] = newValue


                            if (
                            (_fieldToUpdate?.nullable == true) // columnas que admiten nulos
                            || (_fieldToUpdate?.nullable == false && !(newFieldValue == null || newFieldValue == undefined))) // columnas no nulas que llegan valores nulos
                            {

                                const mustSerialize = isColumnType(newField, SqlTypesConst.BIT)                            
                                dataUpdate.valores.push
                                (
                                    {
                                        dataBase: dataBaseId.value ?? '',
                                        table: tableName ?? '',
                                        field: newField,
                                        value: mustSerialize ? JSON.stringify(newFieldValue) as any : newFieldValue as any,//JSON.stringify(newValue) as any
                                    })   
                            }

                         
                        }
                    })


                const doOperationTransaction = ((Object.keys(lookUpData.value ?? {})?.length ?? 0) > 2) || dataUpdate.valores.length > 1;
                saveData(data, _field, newValue, dataUpdate, doOperationTransaction);

                //emit('saveData', {campo:field, valor:newValue, claves:getPrimaryKeys(field)});
            }

        };

        const getPrimaryKeys = (data: any, columna: string): clave[] => {
            const _outputData: clave[] = [];
            //var _data = columna.split(DELIMITERFIELDS);
            const tableName = tablasData.value.find(x => columna == (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field))?.tableName

            const keys = tablasData.value.filter(x => x.tableName == tableName && x.primaryKey).map(x =>
                dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field
            );
            keys.forEach(k => {
                _outputData.push({
                    dataBase: dataBaseId.value ?? '',
                    table: tableName ?? '',
                    field: k,
                    value: data[k]
                })
            })

            return _outputData;
        }

        const changePage = () => {
            menus.value = []
        };

        const toggleMenu = (event: any, data: any) => {
            const id = getDataKey(data);
            const mnuData = menus.value.filter(x => x.id == id);
            if (mnuData.length > 0) {
                mnuData[0].menu.toggle(event);
            }
        };

        const hideMenu = (data: any) => {
            const id = getDataKey(data);
            const mnuData = menus.value.filter(x => x.id == id);
            if (mnuData.length > 0) {

                mnuData[0].menu.hide();
            }
        };


        const buildActionMenu = (data: any) => {


            //return props.menuActionItems?.filter(x => x.visible)
            const actions = props.menuActionItems.map(x => (
                {
                    key: x.key,
                    label: x.label,
                    class: x.class,
                    visible: x.visible,
                    icon: x.icon,
                    command: (event: any) => {
                        if (x?.command) {                            
                            selectRow(data);
                            x?.command(data);
                        }

                        hideMenu(data);
                    }
                }
            ))


            return actions.filter(x => x.visible);
        }

        const createMenuData = (id: any, el: any) => {
            const data = menus.value.filter(x => x.id == id);

            if (data.length == 0) {
                menus.value.push({ id: id, menu: el });
            }

        };


        const getDataKeyName = (): string => {
            let key = '';
            tablasData.value.filter(x => props.filterTablas.includes(x.tableName) && x.primaryKey).forEach(t =>
                key += dataBaseId.value + DataSourceConst.DELIMITERFIELDS + t.tableName + DataSourceConst.DELIMITERFIELDS + t.field

            )
            return key;

        }

        const getDataKey = (data: any): string => {
            let key = '';
            tablasData.value.filter(x => props.filterTablas.includes(x.tableName) && x.primaryKey).forEach(t =>
                key += data[dataBaseId.value + DataSourceConst.DELIMITERFIELDS + t.tableName + DataSourceConst.DELIMITERFIELDS + t.field]

            )
            return key;

        }

        const getDataKeys = (data: any, tabla: string): clave[] => {

            const _outputData: clave[] = [];


            const keys = tablasData.value.filter(x => x.tableName.toLowerCase() == tabla.toLowerCase() && x.primaryKey).map(x =>
                dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field
            );
            keys.forEach(k => {
                _outputData.push({
                    dataBase: dataBaseId.value ?? '',
                    table: tabla,
                    field: k,
                    value: data[k]
                })
            })

            return _outputData;

        }

        const builUrlImage = (data: string) => {
            const type = 'application/octet-stream'
            const fileURL = "data:" + type + ";base64," + (data ?? '');
            return fileURL;

        }



        const verDetalle = (data: any) => {

            let datakeys: clave[] = []
            tablasData.value.map(x => x.tableName).filter((value: any, index: any, self: any) => self.indexOf(value) === index).forEach(tableName => {
                const _keys = getDataKeys(data, tableName)
                _keys.forEach(_k => {
                    datakeys.push(_k)
                })
            })

            emit('click:viewDetail', { keys: datakeys, item: data })

        }


        const selectRow = (data: any) => {

            let datakeys: clave[] = []
            tablasData.value.map(x => x.tableName).filter((value: any, index: any, self: any) => self.indexOf(value) === index).forEach(tableName => {
                const _keys = getDataKeys(data, tableName)
                _keys.forEach(_k => {
                    datakeys.push(_k)
                })
            })

            emit('click:SelectRow', { keys: datakeys, item: data })

            }

        const doRefreshData = () => {
            op.value = false;
            opMassiveUpdate.value = false;
            selectedItems.value = [];
            emit('click:refreshData');
        }

        const deleteItem = (item: any) => {


            const keys = Object.keys(item)
            const _claves = getPrimaryKeys(item, keys[0])
            const description = _claves.map(x => x.field.replace(x.dataBase + DataSourceConst.DELIMITERFIELDS, '').replace(x.table + DataSourceConst.DELIMITERFIELDS, '') + ':' + item[x.field]).join(',')


            var doCallbackOk = () => {

                const dataUpdate: dataUpdate =
                {
                    valores: [] as any,
                    claves: _claves,
                    tipoOperacion: OperationDataTypeConst.DELETE,
                    id: HelperUtils.newGuid()
                }

                deleteData(dataUpdate);
            }



            MessageService.showMessage(MessageType.Pregunta, '', '¿Eliminar registro "' + description + '" ?', true, true, false, '', doCallbackOk, null);

        }

        const openReportLauncher = (url: string) => {

            const cfg = store.getters.getAppConfig;
            if (cfg.length > 0) {
                const urlLaunquer = cfg.find(x => x.idKeyType == 'appconfig-template-urlreportlauncher')?.keyValue;
                window.open((urlLaunquer ?? '') + '?query=' + url, '_blank');
            }
        }

        const openLink = (url: string) => {

            window.open(url, '_blank');
        }

        const getFieldName = (col: any) => {
            if (isColumnType(col.field, SqlTypesConst.DATE) || isColumnType(col.field, SqlTypesConst.DATETIME)) {
                return col.field
            }

            return col.field + DataSourceConst.DELIMITERFIELDFORMAT
        }

        const selectedLookUpData = (data: any) => {
            lookUpData.value = data;
        }


        onMounted(() => {
            showHeader.value = props.showHeaderDetail;
            selectedColumns.value = columnsFiltered.value

            //getTables();            
        });

        onBeforeUpdate(() => {
            menus.value = []
        });

        return {
            op,
            dialogVisible,
            t,
            dt,
            filters,
            data,
            //columns,
            selectedColumns,
            DataSourceConst,
            isCatalogTypeByFieldId,
            onToggle,
            formatData,
            getData,
            isEdit,
            onCellEditComplete,
            onCellEditInit,
            onCellEditCancel,
            isColumnType,
            isColumnIdtipoCampoType,
            isCatalogType,
            SqlTypesConst,
            toggleNew,
            toggleImport,
            columnsFiltered,
            columnsFilteredList,
            changePage,
            buildActionMenu,
            toggleMenu,
            createMenuData,
            getDataKey,
            getCatalogData,
            getCatalogTypeByFieldId,
            CatalogDataTypeConst,
            builUrlImage,
            verDetalle
            , tablas
            , tablasData
            , dataBaseId
            , doRefreshData
            , deleteItem,
            withHeaders,
            toggleUpdateMassive,
            opMassiveUpdate,
            selectedItems,
            getDataKeyName,
            openReportLauncher,
            openLink,
            showHeader,
            getIconHeader,
            getFieldName,
            hasLookUpByFieldId,
            getLookUpByFieldId,
            selectedLookUpData,
            hasLookUpByFieldType  ,
            itemsMenuRadial          

        };
    },
});
